// extracted by mini-css-extract-plugin
module.exports = {"emoji":"Emoji__emoji___EkU_9","modal":"Emoji__modal___ChXtH","a":"Emoji__a___74zg-","modal__copyright":"Emoji__modal__copyright___3y4le","icon":"Emoji__icon___2yu8N"};